module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-144x144-1a6e905b9f4656e2b4383312a0a47fa8.png";